export default {
    // Header
    brand: 'PlayCatGames',
    nav: {
        home: 'ホーム',
        games: 'ゲーム',
        categories: 'カテゴリー',
        about: 'について'
    },
    search: {
        placeholder: '猫ゲームを検索...'
    },

    // Hero Section
    hero: {
        title: '猫ゲーム',
        description: 'PlayCatGamesの猫ゲームでは、さまざまな楽しくて賢い方法で仮想の猫と遊び、世話をし、交流することができます。画面におもちゃを投げたり、キャラクターに衣装をドラッグ＆ドロップしたり、素早い反射神経で魚を捕まえたり報酬を追いかけたりできます。',
        subtitle: 'いくつかの猫ゲームはジャンプ、走る、登るときのタイミングをテストし、他のゲームは餌やり、グルーミング、タップしてポイントを獲得するなどの簡単なアクションに焦点を当てています。すべてのタイトルはブラウザで即座に楽しめるように設計されています。インストール不要、ダウンロード不要、ただニャーオ！',
        buttons: {
            start: 'ゲームを始める',
            browse: 'カテゴリーを見る'
        },
        stats: {
            games: '無料ゲーム',
            categories: 'ゲームカテゴリー',
            free: '無料体験',
            available: 'いつでも利用可能'
        }
    },

    // Games Section
    games: {
        title: '人気の猫ゲーム',
        subtitle: '全年齢対象の最も人気のある無料オンライン猫ゲームを発見しよう',
        filters: {
            all: 'すべて',
            dressUp: 'ドレスアップ',
            care: 'ケア',
            puzzle: 'パズル',
            arcade: 'アーケード',
            simulation: 'シミュレーション'
        },
        loadMore: 'もっとゲームを読み込む',
        gameCategories: {
            arcade: 'アーケード',
            simulation: 'シミュレーション',
            care: 'ケア',
            puzzle: 'パズル',
            dressUp: 'ドレスアップ'
        }
    },

    // Categories Section
    categories: {
        title: 'ゲームカテゴリー',
        subtitle: 'すべての猫ゲームは、プレイヤーが最も楽しむ活動を中心に構築されています：スタイリング、ペットケア、または楽しいコースを駆け抜ける',
        browse: 'カテゴリーを見る',
        featuredGames: 'おすすめゲーム',
        gameCount: 'ゲーム',
        types: {
            dressUp: {
                name: '猫ドレスアップゲーム',
                description: '猫のドレスアップゲームで創造性を解き放ちましょう。衣装をミックスし、アクセサリーを追加し、ファンタジーセットから季節の装備まで、テーマルックを解除しましょう。'
            },
            simulation: {
                name: '猫シミュレーション＆ロールプレイ',
                description: 'シミュレーターゲームでは、猫の足跡を歩むことになります。徘徊し、探索し、好奇心旺盛な子猫の生活を送りましょう。'
            },
            puzzle: {
                name: '猫管理＆パズルゲーム',
                description: '戦略ファンのために、猫パズルと管理ゲームは巧妙なひねりを提供します。複数の猫のバランスを取り、トリッキーなスタッキングチャレンジを解決しましょう。'
            },
            arcade: {
                name: '猫アーケード＆アクションゲーム',
                description: '反射神経と敏捷性をテストする高速猫アーケードゲーム。ジャンプ、走る、キャッチし、スリリングなゲーム体験を楽しみましょう。'
            }
        },
        additional: {
            title: 'より多くの猫ゲームタイプを探索',
            description: '私たちの猫ゲームコレクションは、あらゆる気分と好みをカバーしています：ファッションプレイ、ペットケア、トリッキーなパズル、または面白いアーケードラン。私たちのブラウザベースの猫ゲームは無料で安全で、数秒でプレイの準備ができています。',
            motto: 'ゲームを選んで、スタートをタップして、楽しさを生き生きとさせましょう！'
        }
    },

    // About Section
    about: {
        title: 'PlayCatGamesについて',
        description: [
            'PlayCatGamesは、猫ゲームの素晴らしい世界を探索するための究極の目的地です。私たちは、すべての年齢のプレイヤーに適した無料のオンライン猫テーマゲームのコレクションを慎重に厳選しました。',
            'かわいいドレスアップゲームからエキサイティングなアーケードアドベンチャー、温かいケアシミュレーションから巧妙なパズルチャレンジまで、私たちのゲームコレクションは猫愛好家が望むすべてをカバーしています。すべてのゲームは最高のゲーム体験を保証するために慎重に選ばれています。',
            '私たちはゲームが即座で楽しく、簡単にアクセスできるべきだと信じています。だからこそ、私たちのすべてのゲームは、ソフトウェアをダウンロードまたはインストールすることなく、ブラウザで直接実行できます。クリックして遊び始めるだけです！'
        ],
        features: {
            free: '100% 無料ゲーム',
            mobile: 'モバイルフレンドリー',
            instant: 'インスタントプレイ',
            safe: '安全で安心'
        },
        faq: {
            title: 'よくある質問',
            questions: {
                free: {
                    q: 'これらのゲームは本当に無料ですか？',
                    a: 'はい！私たちの猫ゲームはすべて完全に無料です。すべてのゲームコンテンツを楽しむために何も支払う必要はありません。'
                },
                download: {
                    q: 'ソフトウェアをダウンロードする必要がありますか？',
                    a: 'いいえ！すべてのゲームはブラウザで直接実行できます。ゲームをクリックするだけでプレイを開始でき、ダウンロードやインストールは必要ありません。'
                },
                age: {
                    q: 'これらのゲームはどの年齢層に適していますか？',
                    a: '私たちの猫ゲームはすべての年齢のプレイヤーに適しています。シンプルなドレスアップゲームから挑戦的なパズルゲームまで、誰もが自分に合ったゲームを見つけることができます。'
                },
                mobile: {
                    q: 'ゲームはモバイルデバイスをサポートしていますか？',
                    a: 'はい！私たちのすべてのゲームは、PC、タブレット、電話で完璧に動作するように最適化されています。いつでもどこでもゲームの楽しさを楽しむことができます。'
                },
                updates: {
                    q: '新しいゲームを追加しますか？',
                    a: 'もちろん！私たちは定期的にゲームライブラリを更新し、新しい興味深い猫ゲームを追加します。最新のゲームコンテンツをチェックするために頻繁に戻ってきてください。'
                }
            }
        }
    },

    // Footer
    footer: {
        description: 'あなたの無料オンライン猫ゲームコレクションの目的地。数十の刺激的な猫テーマゲームを発見し、プレイし、楽しんでください。',
        quickLinks: 'クイックリンク',
        gameCategories: 'ゲームカテゴリー',
        support: 'サポート',
        links: {
            popularGames: '人気ゲーム',
            latestGames: '最新ゲーム',
            recommendedGames: 'おすすめゲーム',
            faq: 'よくある質問',
            contact: 'お問い合わせ',
            feedback: 'フィードバック',
            privacy: 'プライバシーポリシー',
            terms: '利用規約',
            cookies: 'クッキーポリシー',
            sitemap: 'サイトマップ'
        },
        copyright: '全著作権所有。',
        disclaimer: 'すべてのゲームコンテンツはエンターテイメントと教育目的でのみインターネットから調達されています。著作権の問題がある場合はお問い合わせください。',
        backToTop: 'トップに戻る',
        friendlyLinks: '友好サイト'
    },

    // Game Data
    gameData: {
        descriptions: {
            kittyLovesBirds: '子猫が飛ぶ鳥を捕まえるのを手伝い、反応速度を示しましょう',
            catPizza: '猫ピザショップを経営し、顧客のために美味しいピザを作りましょう',
            funnyKittyCare: 'かわいい子猫の世話をし、餌やり、入浴、遊びをしましょう',
            catsDrop: 'バランスと戦略スキルをテストする猫スタッキングゲーム',
            catpad: 'かわいい猫プラットフォームジャンピングゲーム',
            funnyKittyDressup: 'さまざまな服やアクセサリーでかわいい子猫をドレスアップ',
            kittyCats: '複数のかわいい猫と交流するカジュアルゲーム',
            dualCat: '二匹の猫を同時にコントロールするチャレンジゲーム',
            funnyKittyHaircut: '子猫のためのファッショナブルなヘアスタイルをデザインする美容ゲーム',
            catCoffeeShop: '猫カフェを経営し、美味しい飲み物を作りましょう'
        },
        categories: {
            puzzle: 'パズル',
            simulation: 'シミュレーション',
            casual: 'カジュアル',
            action: 'アクション',
            adventure: 'アドベンチャー',
            strategy: 'ストラテジー',
            sports: 'スポーツ',
            racing: 'レーシング',
            dressup: 'ドレスアップ',
            care: 'ケア'
        },
        tags: {
            cute: 'かわいい',
            anime: 'アニメ',
            dark: 'ダーク',
            funny: '面白い',
            educational: '教育的',
            multiplayer: 'マルチプレイヤー',
            relaxing: 'リラックス',
            challenging: 'チャレンジング',
            colorful: 'カラフル',
            simple: 'シンプル',
            complex: '複雑',
            family: 'ファミリーフレンドリー',
            kids: '子供向け',
            adult: '大人向け'
        }
    },

    // Common
    common: {
        loading: '読み込み中...',
        error: '何かが間違っています',
        retry: '再試行',
        play: 'ゲームをプレイ',
        language: '言語',
        backToHome: 'ホームに戻る'
    },

    // Legal Pages (simplified)
    legal: {
        privacy: {
            title: 'プライバシーポリシー',
            lastUpdated: '最終更新'
        },
        terms: {
            title: '利用規約',
            lastUpdated: '最終更新'
        },
        cookies: {
            title: 'クッキーポリシー',
            lastUpdated: '最終更新'
        }
    },

    // Sitemap
    sitemap: {
        title: 'サイトマップ',
        description: 'PlayCatGamesウェブサイトのすべてのページとコンテンツを見つける'
    }
}